import React from 'react';
import { Gift } from 'lucide-react';
import InviteCodeCard from './InviteCodeCard';

/**
 * InviteCodesList Component
 * Displays a list of invite codes in a grid layout with empty state
 *
 * @param {Object} props - Component props
 * @param {Array} props.inviteCodes - Array of invite code objects
 * @param {Function} props.onCopyCode - Callback when copy button is clicked
 * @param {Function} props.onDeleteCode - Callback when delete button is clicked
 */
const InviteCodesList = ({ inviteCodes, onCopyCode, onDeleteCode }) => {
  if (!inviteCodes || inviteCodes.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow">
        <div className="p-6">
          <div className="text-center py-8 text-gray-500">
            <Gift className="w-12 h-12 mx-auto mb-4 text-gray-300" />
            <p className="text-lg font-medium">No invite codes generated yet</p>
            <p className="text-sm mt-2">Click the "Generate Code" button to create your first invite code</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6">
        <div className="space-y-4">
          {inviteCodes.map((code) => (
            <InviteCodeCard
              key={code._id}
              inviteCode={code}
              onCopy={onCopyCode}
              onDelete={onDeleteCode}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default InviteCodesList;
